var map = {
	"./PUBLIC_BarItems.json": "8b2c",
	"./ROLE_ADMIN_BarItems.json": "707e",
	"./ROLE_COMPANY_BarItems.json": "a502",
	"./ROLE_CONTENT_EDITOR_BarItems.json": "a3bd",
	"./ROLE_HEADMASTER_BarItems.json": "e82f",
	"./ROLE_STUDENT_BarItems.json": "03cb",
	"./ROLE_STUDENT_CANDIDATE_BarItems.json": "6a34",
	"./ROLE_TEACHER_BarItems.json": "3f77",
	"./ROLE_TEACHER_CANDIDATE_BarItems.json": "13ee",
	"./ROLE_TUTOR_BarItems.json": "a9aa"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8520";